module.exports = __webpack_public_path__ + "static/img/status_indication06.ee8e284.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/airplus_se/status_indication06.png
// module id = MILs
// module chunks = 1